/* eslint-disable no-unused-vars */
// @todo (CHAIR-18484) - Remove eslint-disable during next phase
import * as AmplitudeBrowser from '@amplitude/analytics-browser';
import AmplitudeLibrary from 'amplitude';

import CookieUtils from 'chairisher/util/cookie';

import { isBot, isImpersonated, isStaff } from 'chairisher/context/auth';
import { getAmplitudeApiKey, isAmplitudeBrowserSDK2Enabled } from 'chairisher/context/tracking';

let amplitudeLibrary = null;
let isAmplitudeBrowserActive = false;

/**
 * Loads both the Amplitude JS SDK & Amplitude Browser SDK 2.
 * @todo (CHAIR-18484) - Remove Amplitude JS SDK during migration cleanup.
 */
export default function initializeAmplitude() {
    if (!isImpersonated() && !isStaff() && !isBot()) {
        const amplitudeApiKey = getAmplitudeApiKey();

        if (amplitudeApiKey) {
            try {
                // Amplitude JS SDK
                AmplitudeLibrary.init(amplitudeApiKey, null, {
                    includeGclid: true,
                    includeReferrer: true,
                    includeUtm: true,
                    saveParamsReferrerOncePerSession: false,
                    unsetParamsReferrerOnNewSession: true,
                });
                amplitudeLibrary = AmplitudeLibrary;

                // Amplitude Browser SDK 2
                if (isAmplitudeBrowserSDK2Enabled()) {
                    try {
                        let deviceId;
                        let userId;

                        const cookieValue = CookieUtils.getValueFromLegacyAmplitudeCookie();
                        if (cookieValue) {
                            try {
                                ({ deviceId, userId } = JSON.parse(atob(cookieValue)));
                            } catch (e) {
                                console.error('failed to parse legacy amplitude cookie: ', e);
                            }
                        }

                        AmplitudeBrowser.init(amplitudeApiKey, {
                            // @see https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2#autocapture
                            autocapture: {
                                attribution: false, // @todo (CHAIR-18484) - switch to true during next phase
                                pageViews: false,
                                sessions: false,
                                formInteractions: false,
                                fileDownloads: false,
                                // all of the above event types are true by default (attribution added for clarity)
                                // elementInteractions, frustrationInteractions, and networkTracking are false by default
                            },
                            deviceId,
                            userId,
                        });

                        isAmplitudeBrowserActive = true;
                    } catch (e) {
                        console.error('failed to initialize amplitude browser:', e);
                    }
                }

                return amplitudeLibrary;
            } catch (e) {
                console.error('failed to initialize amplitude:', e);
            }
        }
    }

    return null;
}
